let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3aFI2")).then(() => parcelRequire('dWAhE'));